// extracted by mini-css-extract-plugin
module.exports = {"pairDocumentsWindow":"pairDocumentsWindow__XVoGM","hidden":"hidden__8fDIm","modalDialog":"modalDialog__OfCnZ","contentWrap":"contentWrap__rAJZL","tabs":"tabs__5qeVc"};